import axios from "axios";
import { getEmbedToken } from "./api";

/**
 * Resource API — secondary axios instance for CRUD operations.
 * Uses the same FastAPI base URL.
 */
const RESOURCE_API = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 90000,
  headers: {
    "Content-Type": "application/json",
  },
});

RESOURCE_API.interceptors.request.use(
  (config) => {
    const token = getEmbedToken() || localStorage.getItem("authToken") || "";
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor
RESOURCE_API.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("Resource API Error:", error);
    return Promise.reject(error);
  }
);

export default RESOURCE_API;
